import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTheme } from '@mui/material';

const ToolkitPage = () => {
  const { t } = useTranslation(['navMenu']);
  const url = process.env.REACT_APP_TOOLKIT_URL || '';
  const theme = useTheme();
  const handleOpenLink = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    // Added a title to the page
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        textAlign: 'center',
      }}
      data-testid="toolkit-link-page"
    >
      <Box
        sx={{
          maxWidth: 600,
          padding: 4,
          borderRadius: 2,
          boxShadow: 10,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          {t('toolkit.openedInNewTab')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          {t('toolkit.message')}
        </Typography>
        {url && (
          <>
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="body2"
                sx={{
                  wordBreak: 'break-all',
                  color: 'text.secondary',
                  fontFamily: 'monospace',
                }}
              >
                {url}
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<OpenInNewIcon />}
              onClick={handleOpenLink}
              sx={{ mb: 2 }}
              data-testid="open-external-link-button"
            >
              {t('toolkit.openLink')}
            </Button>
            <Box>
              <Link
                to="/chat"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Button variant="outlined" data-testid="back-to-chat-button">
                  {t('toolkit.backToChat')}
                </Button>
              </Link>
            </Box>
          </>
        )}
        {!url && (
          <Typography variant="body2" color="error">
            {t('toolkit.noUrl')}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ToolkitPage;
